import { render } from "./GazprombankButton.vue?vue&type=template&id=179b6e3b&ts=true"
import script from "./GazprombankButton.vue?vue&type=script&lang=ts"
export * from "./GazprombankButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__